'use client';
import AccountCard from '@/app/[locale]/(protected)/(dashboard)/ui/AccountCard';
import LoadingSpinner from '@/components/ui/client/LoadingSpinner';
import { TableKey } from '@common/application/enums/TableKey';
import useSearchableTable from '@common/application/hooks/useSearchableTable/useSearchableTable';
import { elasticToResponseMapper } from '@common/lib/mappers/response';
import { AccountClient } from '@common/model/apiClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'devextreme-react';
import styles from './AccountSearchView.module.css';

interface AccountSearchViewProps {}

function AccountSearchView(props: AccountSearchViewProps) {
  const { search, setSearch, pit, setPit, nextPage, previousPage, sort, setSort, searchAfter, pageHistory } = useSearchableTable(TableKey.ACCOUNT, { throttle: true });

  const {
    data: searchData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ['accounts_home_search', search, searchAfter, sort],
    queryFn: ({ signal }) => AccountClient.list(search, sort, { deleted: false }, 20, pit, searchAfter, signal),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    placeholderData: (previousData) => previousData,
    enabled: !!search?.length,
  });

  const data = elasticToResponseMapper(searchData).payload;
  return (
    <div className={styles.container}>
      <div className={styles.searchWrapper}>
        <Autocomplete value={search} style={{ width: '100%', position: 'relative', paddingLeft: '26px' }} onValueChanged={(e) => setSearch(e.value ?? '')} />
        <FontAwesomeIcon
          icon={['fas', 'magnifying-glass']}
          style={{ fontSize: 'var(--font-md)', position: 'absolute', left: '10px', top: 0, transform: 'translateY(50%)', pointerEvents: 'none' }}
        />
      </div>

      <div className={styles.view}>
        {isFetching ? (
          <div className={styles.spinner}>
            <LoadingSpinner />
          </div>
        ) : (
          data.map((account) => <AccountCard account={account} key={account.id} isCardView={true} />)
        )}
      </div>
    </div>
  );
}

export default AccountSearchView;
